import React, { useEffect, useState } from 'react';
import { toDateInputValue, toIsoDateTime, toIsoUtc } from '../../utils/dateUtils';
import adminService from '../../services/adminService';
import './CreateJobModal.scss';
import { Search } from "lucide-react";

const JOB_FUNCTIONS = [
  'Abertura/Fechamento de evento',
  'Acessor (a) de eventos',
  'Administrador (a) de eventos',
  'Agente de receptivo',
  'Ajudante de carga e descarga',
  'Ajudante de cozinha',
  'Animador (a)',
  'Apresentador (a)',
  'Artista circense',
  'Assistente de artista',
  'Assistente de camarim',
  'Assistente de decoração',
  'Assistente de eventos',
  'Assistente de palco',
  'Assistente de produção',
  'Assistente de produção artística',
  'Assistente de produção de eventos',
  'Assistente de som',
  'Auxiliar de bar',
  'Auxiliar de bilheteria',
  'Auxiliar de buffet',
  'Auxiliar de buffet de casamento',
  'Auxiliar de credenciamento',
  'Auxiliar de desmontagem',
  'Auxiliar de estoque',
  'Auxiliar de eventos',
  'Auxiliar de governança',
  'Auxiliar de lavanderia',
  'Auxiliar de limpeza',
  'Auxiliar de logística',
  'Auxiliar de manutenção',
  'Auxiliar de montagem',
  'Auxiliar de palco',
  'Auxiliar de recepção',
  'Auxiliar de serviços gerais',
  'Auxiliar de sushiman',
  'Auxiliar de produção',
  'Auxiliar de produção artística',
  'Bailarino (a)',
  'Banda / Grupo musical',
  'Barback',
  'Bartender',
  'Bartender de eventos',
  'Bilheteiro (a)',
  'Bombeiro (a) civil',
  'Brigadista',
  'Cabeleireiro (a)',
  'Cantor (a)',
  'Carregador (a)',
  'Cenógrafo (a)',
  'Cenotécnico (a)',
  'Chef de cozinha',
  'Chapeiro (a)',
  'Cinegrafista',
  'Coletor (a) de resíduos',
  'Concierge',
  'Confeiteiro (a)',
  'Conferente',
  'Controlador (a) de acesso',
  'Coordenador (a) de eventos',
  'Coordenador (a) de produção',
  'Coreógrafo (a)',
  'Criador (a) de conteúdo',
  'Cumim',
  'Decorador (a)',
  'Decorador (a) de eventos',
  'Demonstrador (a) de produtos',
  'Designer de sobrancelhas',
  'DJ',
  'DJ auxiliar',
  'DJ de casamento',
  'Dançarino (a)',
  'Editor (a) de foto',
  'Editor (a) de vídeo',
  'Embaixador (a) de marca',
  'Enfermeiro (a) para eventos',
  'Entregador (a)',
  'Expedidor (a) de pedidos',
  'Faxineiro (a)',
  'Filmmaker',
  'Filmmaker de casamento',
  'Fiscal de evento',
  'Fiscal de salão',
  'Florista',
  'Fotógrafo (a)',
  'Fotógrafo (a) de casamento',
  'Fotógrafo (a) de eventos',
  'Garçom (a)',
  'Garçom (a) de banquete',
  'Garçom (a) de casamento',
  'Gerente de restaurante',
  'Gerente de eventos',
  'Guia de turismo',
  'Guia de turismo bilíngue',
  'Governanta',
  'Host / Hostess',
  'Host de eventos',
  'Hostess de eventos',
  'Influencer',
  'Instrumentista',
  'Intérprete',
  'Lavador (a) de louças',
  'Lavador (a) de roupas',
  'Líder de salão',
  'Maquiador (a)',
  'Maquiador (a) artístico',
  'Manicure',
  'Manobrista',
  'Mágico (a)',
  'Mensageiro (a)',
  'Médico (a) para eventos',
  'Mestre de cerimônias',
  'Modelo',
  'Modelo de passarela',
  'Modelo promocional',
  'Montador (a) de estruturas',
  'Montador (a) de palco',
  'Músico (a)',
  'Músico (a) de casamento',
  'Motorista',
  'Motorista de artistas',
  'Motorista de transporte de equipe',
  'Motorista de van',
  'Motorista particular',
  'Motoboy / Motogirl',
  'Nail designer',
  'Operador (a) de áudio',
  'Operador (a) de câmera',
  'Operador (a) de iluminação',
  'Operador (a) de PDV',
  'Operador (a) de vídeo',
  'Operador (a) de caixa',
  'Operador (a) de bilheteria',
  'Organizador (a) de eventos',
  'Orientador (a) de público',
  'Palhaço (a)',
  'Pedicure',
  'Performer',
  'Pizzaiolo (a)',
  'Piscineiro (a)',
  'Produtor (a) artístico (a)',
  'Produtor (a) de eventos',
  'Produtor (a) de palco',
  'Produtor (a) executivo (a)',
  'Produtor (a) de conteúdo',
  'Promotor (a)',
  'Promotor (a) de degustação',
  'Promotor (a) de eventos',
  'Promotor (a) de marca',
  'Promotor (a) de merchandising',
  'Promotor (a) de vendas',
  'Recepcionista',
  'Recepcionista bilíngue',
  'Recepcionista de eventos',
  'Recepcionista de hotel',
  'Recepcionista de stand',
  'Recepcionista promocional',
  'Recreador (a)',
  'Recreador (a) de hotel',
  'Recreador (a) de piscina',
  'Recreador (a) infantil',
  'Roadie',
  'Salgadeiro (a)',
  'Salva-vidas',
  'Segurança',
  'Segurança de backstage',
  'Segurança de camarim',
  'Segurança patrimonial',
  'Social Media',
  'Socorrista',
  'Sous-chef',
  'Sushiman',
  'Stagehand / Auxiliar de palco',
  'Supervisor (a) de salão',
  'Técnico (a) de enfermagem para eventos',
  'Técnico (a) de iluminação',
  'Técnico (a) de palco',
  'Técnico (a) de som',
  'Técnico (a) de vídeo',
  'Transfer / Transporte turístico',
  'Vendedor (a)',
  'Videomaker',
  'Wedding planner',
];

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

function formatCurrency(value) {
  const numbers = value.replace(/\D/g, '');
  if (!numbers) return '';
  const cents = parseInt(numbers, 10);
  const reais = (cents / 100).toFixed(2);
  return reais.replace('.', ',');
}

function parseCurrency(formatted) {
  const clean = formatted.replace(/\./g, '').replace(',', '.');
  return parseFloat(clean) || 0;
}

// ─── Helper de CEP (mesmo padrão do FreelancerProfileModal) ──────────────────
function formatarCEP(value) {
  return value.replace(/\D/g, '').slice(0, 8).replace(/(\d{5})(\d{1,3})/, '$1-$2');
}

const CreateJobModal = ({
  open,
  onClose,
  criarVaga,
  toast,
  initialDate,
  initialData,
  isEditing,
  isFreePlan = true,
  companyAddress = null,
  onSaveCompanyAddress,
  walletBalance = null,
  onOpenWallet,
}) => {
  const [step, setStep] = useState(1);

  const [questions, setQuestions] = useState(() => {
    if (initialData?.questions?.length > 0) {
      return initialData.questions.map(q => ({
        question: q.question,
        expectedAnswer: q.expectedAnswer,
      }));
    }
    return [];
  });

  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    description: initialData?.description || '',
    location: initialData?.location || '',
    date: toDateInputValue(initialData?.date || initialDate) || '',
    payment: initialData?.payment ? String(initialData.payment).replace('.', ',') : '',
    startTime: initialData?.startTime || '',
    endTime: initialData?.endTime || '',
    isUrgent: initialData?.isUrgent ?? false,
    contactPerson: initialData?.contactPerson || '',
    breakTime: initialData?.breakTime ? String(initialData.breakTime) : '',
    dressCode: initialData?.dressCode || '',
    slots: 1,
    visibility: initialData?.visibility || 'public',
    publishStatus: initialData?.publishStatus || 'published',
    scheduledPublishAt: initialData?.scheduledPublishAt || '',
    privateSlug: initialData?.privateSlug || '',
  });
  const [showFunctionSearch, setShowFunctionSearch] = useState(false);
  const [functionSearch, setFunctionSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [fees, setFees] = useState({
    adminFeePercentage: 10,
    urgentJobFee: 15,
  });

  // ─── NOVO: estado do endereço da empresa ──────────────────────────────────
  const [localAddress, setLocalAddress] = useState(companyAddress);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [savingAddress, setSavingAddress] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const [addressForm, setAddressForm] = useState({
    cep: '',
    logradouro: '',
    bairro: '',
    cidade: '',
    estado: '',
    numero: '',
    complemento: '',
    lat: undefined,
    lng: undefined,
  });


  const addressHasCep = !!(localAddress?.cep && localAddress.cep.replace(/\D/g, '').length === 8);
  const addressValid = !!localAddress && addressHasCep;

  // Calcula o valor numérico atual do pagamento para usar nas validações visuais
  const currentPaymentValue = parseCurrency(formData.payment);
  // CreateJobModal.jsx — adicionar esse useState junto dos outros
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const serviceFee = isFreePlan
    ? Number((currentPaymentValue * (fees.adminFeePercentage / 100)).toFixed(2))
    : 0;
  const urgentFee = formData.isUrgent ? Number(fees.urgentJobFee.toFixed(2)) : 0;
  const totalPerJob = Number((currentPaymentValue + serviceFee + urgentFee).toFixed(2));
  const slotsCount = formData.slots || 1;
  const totalAll = totalPerJob * slotsCount;

  // ─── NOVO: verificação de saldo ────────────────────────────────────────────
  const walletLoaded = walletBalance != null;
  const isWalletEmpty = walletLoaded && walletBalance <= 0;
  const isInsufficientForJob = walletLoaded && currentPaymentValue > 0 && walletBalance < totalPerJob;
  const showBalanceWarning = isWalletEmpty || isInsufficientForJob;
  const missingAmount = isInsufficientForJob ? Number((totalPerJob - walletBalance).toFixed(2)) : 0;

  const handleGoToWallet = () => {
    onOpenWallet?.();
    onClose?.();
  };


  useEffect(() => {
    if (initialDate) {
      setFormData(prev => ({ ...prev, date: toDateInputValue(initialDate) }));
    }
  }, [initialDate]);

  useEffect(() => {
    if (!open) return;

    let isMounted = true;

    const loadFees = async () => {
      try {
        const data = await adminService.getFees();
        if (!isMounted) return;

        // console.log('Taxas carregadas na modal:', data);
        setFees({
          adminFeePercentage: Number(data?.adminFeePercentage ?? 10),
          urgentJobFee: Number(data?.urgentJobFee ?? 15),
        });
      } catch (error) {
        console.error('Erro ao carregar taxas da plataforma:', error);
      }
    };

    loadFees();

    return () => {
      isMounted = false;
    };
  }, [open]);

  // ─── NOVO: sincroniza o endereço local sempre que o modal abre ───────────
  useEffect(() => {
    if (open) {
      setLocalAddress(companyAddress || null);
      setShowAddressForm(false);
      setAddressForm({
        cep: '', logradouro: '', bairro: '', cidade: '', estado: '',
        numero: '', complemento: '', lat: undefined, lng: undefined,
      });
    }
  }, [open, companyAddress]);

  // ─── NOVO: autobusca de CEP (mesmo padrão do FreelancerProfileModal) ─────
  const buscarCepEmpresa = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;

    setLoadingCep(true);

    try {
      const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cepLimpo}`);

      if (!response.ok) {
        toast?.({ title: 'CEP não encontrado', variant: 'destructive' });
        return;
      }

      const data = await response.json();
      const lat = data.location?.coordinates?.latitude;
      const lng = data.location?.coordinates?.longitude;

      setAddressForm(prev => ({
        ...prev,
        cep: data.cep || cepLimpo,
        logradouro: data.street || '',
        bairro: data.neighborhood || '',
        cidade: data.city || '',
        estado: data.state || '',
        lat: lat != null ? Number(lat) : prev.lat,
        lng: lng != null ? Number(lng) : prev.lng,
      }));
      // Se a BrasilAPI não retornar coordenadas, o backend deve geocodificar
      // a partir do endereço textual ao salvar (mesma regra já usada no perfil).
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      toast?.({ title: 'Não foi possível buscar o CEP agora. Tente novamente.', variant: 'destructive' });
    } finally {
      setLoadingCep(false);
    }
  };

  // ─── NOVO: salva o endereço da empresa sem sair do modal ─────────────────
  const handleSaveAddress = async () => {
    const cepLimpo = addressForm.cep.replace(/\D/g, '');

    if (cepLimpo.length !== 8) {
      toast?.({ title: 'CEP inválido', description: 'Informe um CEP válido para continuar.', variant: 'destructive' });
      return;
    }

    if (!addressForm.numero) {
      toast?.({ title: 'Número obrigatório', description: 'Informe o número do endereço.', variant: 'destructive' });
      return;
    }

    setSavingAddress(true);

    try {
      const payload = {
        cep: cepLimpo,
        logradouro: addressForm.logradouro,
        numero: addressForm.numero,
        complemento: addressForm.complemento || null,
        bairro: addressForm.bairro,
        cidade: addressForm.cidade,
        estado: addressForm.estado,
        lat: addressForm.lat ?? null,
        lng: addressForm.lng ?? null,
      };

      const result = await onSaveCompanyAddress?.(payload);

      if (result?.success) {
        setLocalAddress(result.address ?? payload);
        setShowAddressForm(false);
        toast?.({ title: 'Endereço salvo!', description: 'Agora sua vaga já pode ser publicada normalmente.' });
      } else {
        toast?.({
          title: 'Erro ao salvar endereço',
          description: result?.message ?? 'Tente novamente.',
          variant: 'destructive',
        });
      }
    } catch (error) {
      console.error('Erro ao salvar endereço da empresa:', error);
      toast?.({ title: 'Erro ao salvar endereço', description: 'Tente novamente mais tarde.', variant: 'destructive' });
    } finally {
      setSavingAddress(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handlePaymentChange = (e) => {
    const formatted = formatCurrency(e.target.value);
    setFormData(prev => ({ ...prev, payment: formatted }));
  };

  // Validação ao tentar avançar do Passo 1 para o Passo 2
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!addressValid) {
      toast?.({
        title: 'Endereço obrigatório',
        description: 'Cadastre o endereço da sua empresa antes de publicar uma vaga — sem isso ela não aparece pra ninguém.',
        variant: 'destructive',
      });
      setShowAddressForm(true);
      return;
    }
    //se tiver saldo insuficiente bloqueia
    if (isInsufficientForJob || isWalletEmpty) {
      toast?.({
        title: 'Saldo insuficiente',
        description: 'Adicione saldo na carteira antes de publicar essa vaga.',
        variant: 'destructive',
      });
      return;
    }

    if (currentPaymentValue < 40) {
      toast?.({
        title: 'Valor não permitido',
        description: 'O pagamento mínimo por vaga deve ser de R$ 40,00.',
        variant: 'destructive',
      });
      return;
    }

    setStep(2);
  };

  const buildPayload = () => ({
    title: formData.title,
    description: formData.description,
    location: formData.location,
    date: toIsoDateTime(formData.date),
    payment: currentPaymentValue,
    startTime: formData.startTime,
    endTime: formData.endTime || null,
    isUrgent: formData.isUrgent,
    contactPerson: formData.contactPerson || null,
    breakTime: formData.breakTime ? parseInt(formData.breakTime) : null,
    dressCode: formData.dressCode || null,
    visibility: formData.visibility,
    publishStatus: formData.publishStatus,
    scheduledPublishAt:
      formData.publishStatus === 'scheduled'
        ? toIsoUtc(formData.scheduledPublishAt)
        : null,
    privateSlug: formData.visibility === 'private_link'
      ? (formData.privateSlug || Math.random().toString(36).substring(2, 10))
      : null,
    batchId: initialData?.batchId || null,
    customQuestions: questions
      .filter(q => q.question.trim() !== '')
      .map(q => ({
        question: q.question.trim(),
        expectedAnswer: q.expectedAnswer,
      })),
  });

  const handleFinalSubmit = async () => {
    if (!addressValid) {
      toast?.({
        title: 'Endereço obrigatório',
        description: 'Cadastre o endereço da sua empresa antes de publicar uma vaga.',
        variant: 'destructive',
      });
      setStep(1);
      setShowAddressForm(true);
      return;
    }

    if (isInsufficientForJob || isWalletEmpty) {
      toast?.({
        title: 'Saldo insuficiente',
        description: 'Adicione saldo na carteira antes de publicar essa vaga.',
        variant: 'destructive',
      });
      setStep(1);
      return;
    }

    if (currentPaymentValue < 40) {
      toast?.({ title: 'Erro ao salvar vaga', description: 'O pagamento deve ser de no mínimo R$ 40,00.', variant: 'destructive' });
      return;
    }
    const slotsCount = isEditing ? 1 : (formData.slots || 1);
    setLoading(true);
    try {
      const payload = buildPayload();

      if (!isEditing && slotsCount > 1) {
        const batchId = generateUUID();
        console.log('batchId gerado:', batchId);
        for (let i = 0; i < slotsCount; i++) {
          await criarVaga?.({ ...payload, batchId });
        }
      } else {
        await criarVaga?.(payload);
      }

      toast?.({
        title: slotsCount > 1
          ? `${slotsCount} vagas criadas com sucesso! 👥`
          : isEditing ? 'Vaga updated com sucesso!' : 'Vaga criada com sucesso!',
        description: isEditing && payload.batchId
          ? 'Todas as vagas do lote foram atualizadas.'
          : 'Freelancers já podem visualizar sua vaga.',
      });

      setFormData({
        title: '', description: '', location: '', date: '', payment: '',
        startTime: '', endTime: '', isUrgent: false, contactPerson: '',
        breakTime: '', dressCode: '', slots: 1, visibility: 'public',
        publishStatus: 'published', scheduledPublishAt: '', privateSlug: '',
      });
      setQuestions([]);
      setStep(1);
      onClose();
    } catch (err) {
      console.error(err);
      console.error(err?.response?.data);

      toast?.({
        title: 'Erro ao salvar vaga',
        description:
          err?.response?.data ||
          err?.message ||
          'Tente novamente mais tarde',
        variant: 'destructive',
      });

    } finally {
      setLoading(false);
    }
  };

  // CreateJobModal.jsx — adicionar essa função, logo antes de handleClose
  const hasUnsavedChanges = () => {
    return (
      formData.title.trim() !== '' ||
      formData.description.trim() !== '' ||
      formData.location.trim() !== '' ||
      formData.payment.trim() !== '' ||
      formData.contactPerson.trim() !== '' ||
      formData.dressCode.trim() !== '' ||
      formData.startTime.trim() !== '' ||
      formData.endTime.trim() !== '' ||
      questions.length > 0
    );
  };

  const handleClose = () => {
    if (hasUnsavedChanges()) {
      setShowCloseConfirm(true);
      return;
    }
    setStep(1);
    setQuestions([]);
    onClose();
  };

  const confirmDiscardAndClose = () => {
    setShowCloseConfirm(false);
    setStep(1);
    setQuestions([]);
    onClose();
  };

  if (!open) return null;
  // console.log(isFreePlan)

  return (
    <div className="cjm-overlay" onClick={(e) => e.target === e.currentTarget && handleClose()}>
      <div className="cjm-modal">
        {/* Header */}
        <div className="cjm-header">
          <h2 className="cjm-title">
            {step === 1 && (isEditing ? 'Editar Vaga' : 'Criar Nova Vaga')}
            {step === 2 && 'Filtro Extra'}
            {step === 3 && 'Visibilidade e Agendamento'}
          </h2>
          <div className="cjm-steps">
            {[1, 2, 3].map(s => (
              <div key={s} className={`cjm-step ${step === s ? 'active' : ''} ${step > s ? 'done' : ''}`}>{s}</div>
            ))}
          </div>
          <button className="cjm-close" onClick={handleClose} aria-label="Fechar">×</button>
        </div>

        {/* ── STEP 1 ── */}
        {step === 1 && (
          <form onSubmit={handleSubmit} className="cjm-body">
            {showBalanceWarning && (
              <div className="cjm-wallet-alert">
                <p className="cjm-wallet-alert__text">
                  {isWalletEmpty
                    ? '💰 Você está sem saldo na carteira para criar uma nova vaga.'
                    : `💰 Saldo insuficiente para essa vaga — faltam R$ ${missingAmount.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}.`}
                </p>
                <button
                  type="button"
                  className="cjm-wallet-alert__link"
                  onClick={handleGoToWallet}
                >
                  Clique para adicionar um saldo e contratar freelancers
                </button>
              </div>
            )}

            <div className="cjm-field">
              <label className="cjm-label">Função</label>

              <div className="cjm-function-row">
                <select
                  className="cjm-select"
                  value={formData.title}
                  onChange={(e) =>
                    handleInputChange('title', e.target.value)
                  }
                  required
                >
                  <option value="" disabled>
                    Selecione a função
                  </option>

                  {JOB_FUNCTIONS.map(fn => (
                    <option key={fn} value={fn}>
                      {fn}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className="cjm-function-search-button"
                  onClick={() => {
                    setShowFunctionSearch(prev => !prev);
                    setFunctionSearch('');
                  }}
                  title="Pesquisar função"
                >
                  <Search size={18} />
                </button>
              </div>

              {showFunctionSearch && (
                <div className="cjm-function-search-box">
                  <input
                    type="text"
                    className="cjm-input"
                    placeholder="Digite o nome da função..."
                    value={functionSearch}
                    onChange={(e) =>
                      setFunctionSearch(e.target.value)
                    }
                    autoFocus
                  />

                  {functionSearch.trim() && (
                    <div className="cjm-function-search-results">
                      {JOB_FUNCTIONS
                        .filter(fn =>
                          fn.toLowerCase().includes(
                            functionSearch.toLowerCase()
                          )
                        )
                        .slice(0, 10)
                        .map(fn => (
                          <button
                            key={fn}
                            type="button"
                            className="cjm-function-search-result"
                            onClick={() => {
                              handleInputChange('title', fn);
                              setShowFunctionSearch(false);
                              setFunctionSearch('');
                            }}
                          >
                            {fn}
                          </button>
                        ))}

                      {JOB_FUNCTIONS.filter(fn =>
                        fn.toLowerCase().includes(
                          functionSearch.toLowerCase()
                        )
                      ).length === 0 && (
                          <div className="cjm-function-no-results">
                            Nenhuma função encontrada.
                          </div>
                        )}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="cjm-field">
              <label className="cjm-label" htmlFor="description">Descrição</label>
              <textarea id="description" className="cjm-textarea" value={formData.description} onChange={(e) => handleInputChange('description', e.target.value)} required placeholder="Descreva os detalhes da vaga..." rows={4} />
            </div>

            <div className="cjm-field">
              <label className="cjm-label" htmlFor="location">Local</label>
              <input id="location" className="cjm-input" type="text" value={formData.location} onChange={(e) => handleInputChange('location', e.target.value)} required placeholder="Endereço do evento/trabalho" />

              {/* ── NOVO: aviso + preenchimento inline de endereço da empresa ── */}
              {!addressValid && (
                <div className="cjm-address-alert">
                  <p className="cjm-address-alert__text">
                    ⚠️ Sua empresa ainda não tem um endereço completo cadastrado. Sem isso, a vaga não aparece pra nenhum freelancer.
                  </p>

                  {!showAddressForm ? (
                    <button
                      type="button"
                      className="cjm-address-link"
                      onClick={() => setShowAddressForm(true)}
                    >
                      Preencher endereço agora
                    </button>
                  ) : (
                    <div className="cjm-inline-address">
                      <div className="cjm-field">
                        <label className="cjm-label pem-label--xs">CEP</label>
                        <input
                          className="cjm-input"
                          type="text"
                          inputMode="numeric"
                          maxLength={9}
                          placeholder="00000-000"
                          value={addressForm.cep}
                          onChange={(e) => {
                            const cep = formatarCEP(e.target.value);
                            setAddressForm(prev => ({ ...prev, cep }));
                            if (cep.replace(/\D/g, '').length === 8) {
                              buscarCepEmpresa(cep);
                            }
                          }}
                        />
                        <p className="cjm-hint">
                          {loadingCep ? 'Buscando endereço...' : 'Digite o CEP para preencher o resto automaticamente.'}
                        </p>
                      </div>

                      {addressForm.logradouro && (
                        <p className="cjm-hint">
                          {addressForm.logradouro} — {addressForm.bairro}, {addressForm.cidade}/{addressForm.estado}
                        </p>
                      )}

                      <div className="cjm-grid-2">
                        <div className="cjm-field">
                          <label className="cjm-label pem-label--xs">Número</label>
                          <input
                            className="cjm-input"
                            value={addressForm.numero}
                            onChange={(e) => setAddressForm(prev => ({ ...prev, numero: e.target.value }))}
                            placeholder="Ex: 123"
                          />
                        </div>
                        <div className="cjm-field">
                          <label className="cjm-label pem-label--xs">Complemento</label>
                          <input
                            className="cjm-input"
                            value={addressForm.complemento}
                            onChange={(e) => setAddressForm(prev => ({ ...prev, complemento: e.target.value }))}
                            placeholder="Ex: Sala 2"
                          />
                        </div>
                      </div>

                      <div className="cjm-inline-address__actions">
                        <button
                          type="button"
                          className="cjm-btn cjm-btn--outline cjm-btn--sm"
                          onClick={() => setShowAddressForm(false)}
                          disabled={savingAddress}
                        >
                          Cancelar
                        </button>
                        <button
                          type="button"
                          className="cjm-btn cjm-btn--primary cjm-btn--sm"
                          onClick={handleSaveAddress}
                          disabled={savingAddress}
                        >
                          {savingAddress ? 'Salvando...' : 'Salvar endereço'}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="cjm-field">
              <label className="cjm-label" htmlFor="date">Data</label>
              <input
                id="date"
                className="cjm-input"
                type="date"
                value={formData.date}
                onChange={(e) => handleInputChange('date', e.target.value)}
                // min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>

            {/* CAMPO DE PAGAMENTO MODIFICADO */}
            <div className="cjm-field">
              <label className="cjm-label" htmlFor="payment">Valor a Pagar (R$)</label>
              <div className="cjm-input-prefix">
                <span className="cjm-prefix">R$</span>
                <input id="payment" className="cjm-input" type="text" inputMode="numeric" value={formData.payment} onChange={handlePaymentChange} required placeholder="0,00" />
              </div>

              {/* 💡 AVISO TEXTUAL ABAIXO DO INPUT */}
              {formData.payment && currentPaymentValue < 40 ? (
                <p className="cjm-payment-warning" style={{ color: '#dc2626', fontSize: '0.85rem', marginTop: '6px', fontWeight: '500' }}>
                  ⚠️ Vagas abaixo de R$ 40,00 não são permitidas para combater a remuneração desumana.
                </p>
              ) : (
                <p className="cjm-hint">Pagamento mínimo exigido: R$ 40,00.</p>
              )}
            </div>

            {currentPaymentValue > 0 && (
              <div className="cjm-cost-summary">
                <div className="cjm-cost-row">
                  <span>Valor do freelancer:</span>
                  <span>R$ {currentPaymentValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </div>

                {isFreePlan ? (
                  <div className="cjm-cost-row">
                    <span>Taxa de serviço ({fees.adminFeePercentage}%):</span>
                    <span>R$ {serviceFee.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                  </div>
                ) : (
                  <div className="cjm-cost-row cjm-cost-row--gold-free">
                    <span>🎉 Você tem Gold ativo — sem taxa de serviço!</span>
                  </div>
                )}

                {formData.isUrgent && (
                  <div className="cjm-cost-row cjm-cost-row--urgent">
                    <span>Taxa de destaque (Impulsionar):</span>
                    <span>R$ {urgentFee.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                  </div>
                )}

                <div className="cjm-cost-row cjm-cost-row--total">
                  <span>Total a pagar{slotsCount > 1 ? ' (por vaga)' : ''}:</span>
                  <span>R$ {totalPerJob.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                </div>

                {slotsCount > 1 && (
                  <div className="cjm-cost-row cjm-cost-row--grand-total">
                    <span>Total do lote ({slotsCount} vagas):</span>
                    <span>R$ {totalAll.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                  </div>
                )}
              </div>
            )}

            {/* Quantidade — só na criação */}
            {!isEditing && (
              <div className="cjm-field">
                <label className="cjm-label">Quantidade de Profissionais</label>
                <div className="cjm-counter">
                  <button type="button" className="cjm-counter-btn" disabled={formData.slots <= 1} onClick={() => setFormData(prev => ({ ...prev, slots: Math.max(1, prev.slots - 1) }))}>−</button>
                  <span className="cjm-counter-value">{formData.slots}</span>
                  <button type="button" className="cjm-counter-btn" disabled={formData.slots >= 20} onClick={() => setFormData(prev => ({ ...prev, slots: Math.min(20, prev.slots + 1) }))}>+</button>
                  {formData.slots > 1 && <span className="cjm-badge-batch">👥 Lote: {formData.slots} professionals</span>}
                </div>
                <p className="cjm-hint">
                  {formData.slots > 1
                    ? `Serão abertas ${formData.slots} vagas idênticas. Valor total: R$ ${(currentPaymentValue * formData.slots).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
                    : 'Contratar 1 profissional (padrão)'}
                </p>
              </div>
            )}

            <div className="cjm-urgent-box">
              <div>
                <p className="cjm-urgent-title">Impulsionar Vaga (Urgente)</p>
                <p className="cjm-urgent-desc">Sua vaga fura a fila e aparece com destaque. Notifica freelancers imediatamente. (+ R$ {fees.urgentJobFee.toLocaleString('pt-BR', { minimumFractionDigits: 2 })})</p>
              </div>
              <input type="checkbox" checked={formData.isUrgent} onChange={(e) => setFormData(prev => ({ ...prev, isUrgent: e.target.checked }))} className="cjm-checkbox" />
            </div>

            <div className="cjm-field">
              <label className="cjm-label" htmlFor="contactPerson">Responsável no Local</label>
              <input id="contactPerson" className="cjm-input" type="text" value={formData.contactPerson} onChange={(e) => handleInputChange('contactPerson', e.target.value)} placeholder="Nome de quem vai receber o freelancer" maxLength={100} />
              <p className="cjm-hint">Quem será o ponto de contato do freelancer ao chegar no local.</p>
            </div>

            <div className="cjm-field">
              <label className="cjm-label">Tempo de Descanso</label>
              <select className="cjm-select" value={formData.breakTime} onChange={(e) => handleInputChange('breakTime', e.target.value)}>
                <option value="">Selecione o tempo de descanso</option>
                <option value="15">15 minutos</option>
                <option value="30">30 minutos</option>
                <option value="60">60 minutos (1 hora)</option>
                <option value="90">90 minutos (1h30)</option>
                <option value="120">120 minutos (2 horas)</option>
              </select>
            </div>

            <div className="cjm-field">
              <label className="cjm-label" htmlFor="dressCode">Vestimenta</label>
              <textarea id="dressCode" className="cjm-textarea" value={formData.dressCode} onChange={(e) => handleInputChange('dressCode', e.target.value.substring(0, 200))} placeholder="Ex: Camisa social branca, calça preta, sapato fechado..." maxLength={200} rows={2} />
              <div className="cjm-field-footer">
                <p className="cjm-hint">Descreva a roupa necessária para o freelancer comparecer.</p>
                <span className="cjm-counter-chars">{formData.dressCode.length}/200</span>
              </div>
            </div>

            <div className="cjm-grid-2">
              <div className="cjm-field">
                <label className="cjm-label" htmlFor="startTime">Horário de Entrada</label>
                <input id="startTime" className="cjm-input" type="time" value={formData.startTime} onChange={(e) => handleInputChange('startTime', e.target.value)} required />
              </div>
              <div className="cjm-field">
                <label className="cjm-label" htmlFor="endTime">Horário de Saída</label>
                <input id="endTime" className="cjm-input" type="time" value={formData.endTime} onChange={(e) => handleInputChange('endTime', e.target.value)} required />
              </div>
            </div>

            <div className="cjm-actions">
              <button type="button" className="cjm-btn cjm-btn--outline" onClick={handleClose}>Cancelar</button>
              {/* Opcional: desativa visualmente o botão Avançar se o valor for menor que 80 */}
              <button type="submit" className="cjm-btn cjm-btn--primary" disabled={formData.payment && currentPaymentValue < 40}>Continuar</button>
            </div>
          </form>
        )}

        {/* ── STEP 2 ── */}
        {step === 2 && (
          <div className="cjm-body cjm-fade-in">
            <div className="cjm-section-box">
              <h3 className="cjm-section-title">Filtro Extra <span className="cjm-optional">(Opcional)</span></h3>
              <p className="cjm-section-desc">Adicione até 3 perguntas de Sim/Não. O freelancer só passa no filtro se responder corretamente.</p>

              {questions.map((q, idx) => (
                <div key={idx} className="cjm-question-card">
                  <div className="cjm-question-header">
                    <span className="cjm-question-label">Pergunta {idx + 1}</span>
                    <button type="button" className="cjm-question-remove" onClick={() => setQuestions(questions.filter((_, i) => i !== idx))}>
                      Remover
                    </button>
                  </div>
                  <input
                    className="cjm-input"
                    value={q.question}
                    onChange={(e) => {
                      const newQ = [...questions];
                      newQ[idx] = { ...newQ[idx], question: e.target.value.substring(0, 200) };
                      setQuestions(newQ);
                    }}
                    placeholder="Ex: Você possui experiência com bartending?"
                    maxLength={200}
                  />
                  <div className="cjm-question-footer">
                    <span className="cjm-counter-chars">{q.question.length}/200</span>
                    <div className="cjm-expected">
                      <span className="cjm-expected-label">Resposta correta:</span>
                      <div className="cjm-expected-btns">
                        <button
                          type="button"
                          className={`cjm-answer-btn cjm-answer-btn--yes ${q.expectedAnswer === 'sim' ? 'active' : ''}`}
                          onClick={() => { const newQ = [...questions]; newQ[idx] = { ...newQ[idx], expectedAnswer: 'sim' }; setQuestions(newQ); }}
                        >SIM ✓</button>
                        <button
                          type="button"
                          className={`cjm-answer-btn cjm-answer-btn--no ${q.expectedAnswer === 'nao' ? 'active' : ''}`}
                          onClick={() => { const newQ = [...questions]; newQ[idx] = { ...newQ[idx], expectedAnswer: 'nao' }; setQuestions(newQ); }}
                        >NÃO ✗</button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {questions.length < 3 && (
                <button
                  type="button"
                  className="cjm-btn-add-question"
                  onClick={() => setQuestions([...questions, { question: '', expectedAnswer: 'sim' }])}
                >
                  + Adicionar Pergunta
                </button>
              )}
            </div>

            <div className="cjm-actions">
              <button type="button" className="cjm-btn cjm-btn--outline" onClick={() => setStep(1)}>Voltar</button>
              <button type="button" className="cjm-btn cjm-btn--primary" onClick={() => setStep(3)}>Avançar</button>
            </div>
          </div>
        )}

        {/* ── STEP 3 ── */}
        {step === 3 && (
          <div className="cjm-body cjm-fade-in">
            <div className="cjm-section-box">
              <h3 className="cjm-section-title">Visibilidade da Vaga</h3>
              <p className="cjm-section-desc">Quem pode ver e se candidatar a esta vaga?</p>

              <div className="cjm-radio-group">
                {[
                  { value: 'public', title: 'Pública (Feed)', desc: 'Aparece para todos os freelancers no feed.' },
                  { value: 'private_link', title: 'Link Privado', desc: 'Apenas quem tiver o link exclusivo poderá acessar.' },
                  { value: 'private_invite', title: 'Convite Direto', desc: 'Vaga oculta — você envia convites para freelancers favoritos.' },
                ].map(opt => (
                  <label key={opt.value} className={`cjm-radio-card ${formData.visibility === opt.value ? 'active' : ''}`}>
                    <input
                      type="radio"
                      name="visibility"
                      checked={formData.visibility === opt.value}
                      onChange={() => {
                        if (opt.value === 'private_link') {
                          setFormData(prev => ({ ...prev, visibility: 'private_link', privateSlug: Math.random().toString(36).substring(2, 10) }));
                        } else {
                          handleInputChange('visibility', opt.value);
                        }
                      }}
                    />
                    <div>
                      <p className="cjm-radio-title">{opt.title}</p>
                      <p className="cjm-radio-desc">{opt.desc}</p>
                    </div>
                  </label>
                ))}
              </div>

              <div className="cjm-divider" />
              <h3 className="cjm-section-title">Publicação</h3>
              <p className="cjm-section-desc">Quando a vaga deve aparecer para os candidatos?</p>

              <div className="cjm-radio-group">
                {[
                  { value: 'published', title: 'Publicar Agora' },
                  { value: 'scheduled', title: 'Agendar Publicação' },
                ].map(opt => (
                  <label key={opt.value} className={`cjm-radio-card ${formData.publishStatus === opt.value ? 'active' : ''}`}>
                    <input type="radio" name="publishStatus" checked={formData.publishStatus === opt.value} onChange={() => handleInputChange('publishStatus', opt.value)} />
                    <p className="cjm-radio-title">{opt.title}</p>
                  </label>
                ))}
              </div>

              {formData.publishStatus === 'scheduled' && (
                <div className="cjm-field cjm-scheduled-field">
                  <input className="cjm-input" type="datetime-local" value={formData.scheduledPublishAt} onChange={(e) => handleInputChange('scheduledPublishAt', e.target.value)} required />
                </div>
              )}
            </div>

            <div className="cjm-actions">
              <button type="button" className="cjm-btn cjm-btn--outline" onClick={() => setStep(2)}>Voltar</button>
              <button
                type="button"
                className="cjm-btn cjm-btn--primary"
                disabled={loading || (formData.publishStatus === 'scheduled' && !formData.scheduledPublishAt)}
                onClick={handleFinalSubmit}
              >
                {loading ? 'Processando...' : isEditing ? 'Salvar alterações' : 'Confirmar e Publicar'}
              </button>

            </div>
          </div>
        )}

        {
          showCloseConfirm && (
            <div className="cjm-confirm-overlay" onClick={(e) => e.target === e.currentTarget && setShowCloseConfirm(false)}>
              <div className="cjm-confirm-box">
                <h4 className="cjm-confirm-title">Descartar informações da vaga?</h4>
                <p className="cjm-confirm-text">
                  Você preencheu dados que ainda não foram salvos. Se sair agora, essas informações serão perdidas.
                </p>
                <div className="cjm-confirm-actions">
                  <button
                    type="button"
                    className="cjm-btn cjm-btn--outline"
                    onClick={() => setShowCloseConfirm(false)}
                  >
                    Continuar editando
                  </button>
                  <button
                    type="button"
                    className="cjm-btn cjm-btn--danger"
                    onClick={confirmDiscardAndClose}
                  >
                    Descartar e sair
                  </button>
                </div>
              </div>
            </div>
          )
        }
      </div >
    </div >

  );
};

export default CreateJobModal;